// This function allow to reference all chunks
__webpack_require__.cssAssetFileName = (chunkId) => {
	// return url for filenames based on template
	return "capman-guest-spa-" + chunkId + "." + {"main":"c6bc4aef24ba60978fe7"}[chunkId] + ".css";
};